export const STRUCTURE_HELPER_TEXT = {
  nameHelperText: '',
};